import axios from 'axios'
import store from './store/index' 
import Vue from 'vue'
import router from './router'
//创建axios实例
var service = axios.create({
    // baseURL: 'http://cnfamilybigdata.home121.net:8187', 
    baseURL: 'http://47.104.110.187:8091',
    timeout: 5000, 
        headers: {
        'content-type': 'application/json',
        // 'token': store.state.login.token
    }
}) 

service.interceptors.request.use(
    config => {
        config.headers.token = store.state.login.token
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// 响应拦截
service.interceptors.response.use(res => {
    if (res.data.code === 200 && localStorage.bqtoken) {
        window.localStorage.bqtoken = ''
        window.localStorage.bqPhone = ''
        store.commit('setLoginInf')
        Vue.prototype.$message.warning('登录超时，请重新登录')
        
        router.push({ name: 'login' })
    }
    return res
  })




export default { 
  service,  
    //get请求
    get(url, data) {
        return service({
            url: url,
            method: 'GET',
            data
        })
    },
    // post
    post(url, data) {
        return service({
            url: url,
            method: 'POST',
            data
        })
    }
}